/**
 * mapRawResults
 *
 * Remap rawResults
 *
 * @param {Array} rawResults
 * @return {Array} rawResults
 */
const mapRawResults = rawResults => {
	rawResults.forEach( ( rawResult, i ) => {
		Object.keys( rawResult ).forEach( item => {
			if ( '_meta' === item ) {
				rawResults[ i ][ item ] = rawResults[ i ][ item ];
			} else {
				rawResults[ i ][ item ] = rawResults[ i ][ item ].raw;
			}
		} );
	} );
	return rawResults;
};

export default mapRawResults;
